<template>
  <div class="fl p-l-20 border-box" :style="'width:' + width + ';height:' + height">
    <div class="bor-deep-gra bg-wh h-100p ovf-auto">
      <p class=" ft-bold p-t-20 p-b-20 m-t-0 m-b-0 m-l-30 m-r-30 bor-b-gray">配置项</p>
      <div class="p-t-20 p-l-30 p-r-30">
        <el-form ref="form" :model="curNode" label-width="100px">
          <el-form-item label="路由备注" prop="name">
            <el-input v-model="curRoute.remark" class="h-40 w-230"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['curRoute', 'width', 'height'],
    data() {
      return {
      }
    }
  }
</script>


// WEBPACK FOOTER //
// routeConfig.vue?53c43f4c